jQuery(document).ready(function(){
  // jQuery(".announcement-slider").owlCarousel({
  //   loop: true,           // Infinite loop
  //   margin: 10,           // Space between items
  //   nav: false,           // Hide navigation buttons
  //   dots: false,          // Hide dots
  //   autoplay: true,       // Auto slide
  //   autoplayTimeout: 3000, // Change slide every 3 seconds
  //   autoplayHoverPause: true,
  //   responsive:{
  //         0:{
  //             items:1
  //         },
  //         600:{
  //             items:3
  //         },
  //         1000:{
  //             items:3
  //         }
  //     }
  // });

  // document.getElementById('clear-cart-button').addEventListener('click', function() {
  //   // Clear the cart
  //   fetch('/cart/clear.js', {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json'
  //     },
  //   })
  //   .then(function(response) {
  //     return response.json();
  //   })
  //   .then(function(data) {
  //     // Refresh the cart drawer after clearing
  //     updateCartDrawer(); // You will need to call a function that updates the cart drawer
  //   })
  //   .catch(function(error) {
  //     console.error('Error clearing the cart:', error);
  //   });
  // });
    jQuery(document).on("click", ".se-show-individual", function(){
      // SaGó: el modal es `fixed` y vive en la columna de compra, que tiene la
      // animación de entrada de Dawn: sin quitarla, el modal se centraba en la
      // columna y no en la pantalla (sago-overrides.css, .sago-sin-animacion).
      jQuery(this).closest(".product__info-wrapper").addClass("sago-sin-animacion");
      jQuery(this).parent().find(".se-modal").addClass('show');
    });
    jQuery(document).on("click", ".se-modal-close", function(){
      jQuery(this).parents(".se-modal").removeClass('show');
    });





  
  jQuery(document).on("click", ".se-modal-overlay", function(){
    jQuery(".se-modal").removeClass('show');
    jQuery(this).hide();
  });
  
  jQuery(document).on("click", ".product__accordion11 .accordion__title", function(){
      if(jQuery(this).parent().find(".accordion__content").hasClass('hide')) {
        console.log("INN")
        jQuery(this).parent().find(".accordion__content").removeClass('hide').addClass('show');
      } else {
        jQuery(this).parent().find(".accordion__content").removeClass('show').addClass('hide');
      }
      
    });
  jQuery(document).on("click", ".footer-block h2", function(e){
    jQuery(this).parent().toggleClass('active');
    console.log('footer-clic');
});








  // Function to refresh the cart drawer
  function updateCartDrawer() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        // Update the cart drawer with the new cart information
        const cartDrawer = document.querySelector('.cart-drawer'); // Adjust this selector to match your theme's cart drawer
        const cartItemsContainer = cartDrawer.querySelector('.cart-items');
        
        // Clear the cart items
        cartItemsContainer.innerHTML = '';

        // Check if the cart is empty
        if (data.items.length === 0) {
          cartItemsContainer.innerHTML = '<p>Your cart is empty.</p>';
        } else {
          // Add cart items back into the drawer (or you can display a message)
          data.items.forEach(function(item) {
            const cartItemHtml = `
              <div class="cart-item">
                <img src="${item.image}" alt="${item.title}" />
                <p>${item.quantity} x ${item.title}</p>
              </div>
            `;
            cartItemsContainer.innerHTML += cartItemHtml;
          });
        }

        // Optionally, update the cart drawer total
        const cartTotal = cartDrawer.querySelector('.cart-total');
        cartTotal.textContent = `$${data.total_price / 100}`;
      });
  }

  
});$(document).ready(function() {

 
 if (window.innerWidth < 768) {  
    new Swiper('.howitwork-slider', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        499: {
            slidesPerView: 1,
            spaceBetweenSlides: 30
        },
        999: {
            slidesPerView: 4,
            spaceBetweenSlides: 30
        }
    }
    });

    jQuery(".sago-delivery-cta .multicolumn-card").addClass('swiper-wrapper');
    jQuery(".sago-delivery-cta .multicolumn-item").addClass('swiper-slide');
   setTimeout(function(){
     new Swiper('.sago-delivery-cta', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      breakpoints: {
        499: {
            slidesPerView: 1,
            spaceBetweenSlides: 30
        },
        999: {
            slidesPerView: 1,
            spaceBetweenSlides: 30
        }
    }
    });
     }, 200);
 }
});




// sago club 


  new Swiper('.sago_club_image', {
  loop: true,
  slidesPerView: 3,
  spaceBetween: 20,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.sago-next-arrow',
    prevEl: '.sago-prev-arrow',
  },
  breakpoints: {
    // Responsive settings
    0: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    }
  }
});

$(document).ready(function() {
  $('.custom-header').hover(
    function() {
      $(this).addClass('active-hover'); // Add class on hover
    },
    function() {
      $(this).removeClass('active-hover'); // Remove class when hover ends
    }
  );
});

























// Función filtrado personas - Versión optimizada
document.addEventListener('DOMContentLoaded', function() {
  
  // Función para manejar clics en botones de personas
  function clickPersona(idBoton, textoFiltro) {
    const boton = document.getElementById(idBoton);
    if (!boton) {
      console.warn(`Botón con ID ${idBoton} no encontrado`);
      return;
    }
    
    boton.addEventListener('click', function() {
      console.log(`Buscando filtro: "${textoFiltro}"`);
      
      // Busca el label cuyo span contenga el texto exacto
      const labels = document.querySelectorAll('label.facets__label.facet-checkbox');
      let encontrado = false;
      
      for (const label of labels) {
        const texto = label.querySelector('.facet-checkbox__text-label');
        if (texto && texto.textContent.trim() === textoFiltro) {
          const input = label.querySelector('input[type="checkbox"]');
          if (input) {
            input.click();
            console.log(`Filtro "${textoFiltro}" activado`);
            encontrado = true;
            break;
          }
        }
      }
      
      if (!encontrado) {
        console.warn(`No se encontró el filtro: "${textoFiltro}"`);
      }
    });
  }

  // Configurar todos los botones
  clickPersona('personas2', '2 PERS.');
  clickPersona('personas4', '4 PERS.');
  clickPersona('personas6', '6 PERS.');
  clickPersona('personas8', '8 PERS.');
  clickPersona('personas10', '10 PERS.');
  clickPersona('personas16', '16');
});

// Función para actualizar clases según estado del input - OPTIMIZADA
function actualizarClasePersona(idInput, idBoton) {
  const input = document.getElementById(idInput);
  const boton = document.getElementById(idBoton);
  
  // Si no existe alguno de los elementos, salir silenciosamente
  if (!input || !boton) {
    return;
  }

  // Actualizar clase según estado del checkbox
  if (input.checked) {
    boton.classList.add('personaactiva');
  } else {
    boton.classList.remove('personaactiva');
  }
}

// Función para actualizar todas las clases - OPTIMIZADA
function actualizarTodas() {
  const mappings = [
    ['Filter-filter.p.m.custom.numero_de_personas-1', 'personas2'],
    ['Filter-filter.p.m.custom.numero_de_personas-2', 'personas6'], 
    ['Filter-filter.p.m.custom.numero_de_personas-3', 'personas10'],
    ['Filter-filter.p.m.custom.numero_de_personas-4', 'personas4'],
    ['Filter-filter.p.m.custom.numero_de_personas-5', 'personas16'],
    ['Filter-filter.p.m.custom.numero_de_personas-6', 'personas8']
  ];
  
  // Solo procesar mappings donde ambos elementos existan
  mappings.forEach(([inputId, botonId]) => {
    const input = document.getElementById(inputId);
    const boton = document.getElementById(botonId);
    
    // Solo actualizar si ambos elementos existen
    if (input && boton) {
      actualizarClasePersona(inputId, botonId);
    }
  });
}

// Función debounced para evitar múltiples ejecuciones
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Ejecutar al cargar la página
document.addEventListener('DOMContentLoaded', function() {
  // Esperar un poco para que el DOM esté completamente cargado
  setTimeout(actualizarTodas, 500);
});

// Observer optimizado
const debouncedUpdate = debounce(actualizarTodas, 200);

// Buscar un contenedor más específico si es posible
const contenedorFiltros = document.querySelector('.facets') || document.querySelector('body');

if (contenedorFiltros) {
  const observer = new MutationObserver(function(mutations) {
    let shouldUpdate = false;
    
    mutations.forEach(function(mutation) {
      // Solo actualizar si hay cambios relevantes
      if (mutation.type === 'childList' || 
          (mutation.type === 'attributes' && mutation.attributeName === 'checked')) {
        shouldUpdate = true;
      }
    });
    
    if (shouldUpdate) {
      debouncedUpdate();
    }
  });
  
  observer.observe(contenedorFiltros, { 
    childList: true, 
    subtree: true, 
    attributes: true,
    attributeFilter: ['checked']
  });
}

// Event listener para clicks con debounce
document.addEventListener('click', function(e) {
  // Solo actualizar si el click fue en un elemento relevante
  if (e.target.matches('input[type="checkbox"]') || 
      e.target.closest('.facet-checkbox') ||
      e.target.matches('[id^="personas"]')) {
    setTimeout(actualizarTodas, 150);
  }
});

// Función de limpieza global (opcional)
window.limpiarObservadores = function() {
  if (typeof observer !== 'undefined') {
    observer.disconnect();
  }
};











// Función ajusta altura de ficha de producto boxes
$(document).ready(function() {
function ajustarAlturaLista() {
  var activeHeight = $('li.is-active').outerHeight();
  $('ul.product__media-list').stop().animate({ height: activeHeight }, 300);
}

// Ejecutar al iniciar
ajustarAlturaLista();

// Observar cambios en todos los <li> dentro del ul
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.type === "attributes" && mutation.attributeName === "class") {
      if ($(mutation.target).hasClass("is-active")) {
        ajustarAlturaLista();
      }
    }
  });
});

// Seleccionar todos los <li> a observar
$('ul.product__media-list li').each(function() {
  observer.observe(this, { attributes: true });
});
});
